var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","xl9":""}},[_c('invoice-table',{attrs:{"invoices":_vm.allInvoices}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }